(function () {
  const TIER_QUERY = 'jakosc';
  const GRADE_LABELS = {
    Select: 'G/SI1',
    Premium: 'F/VS2',
    Signature: 'E/VVS2',
  };

  function getSelectedQuality(section) {
    const checked = section.querySelector(
      '.variant__option__values--jakosc input[type="radio"]:checked'
    );
    return checked ? checked.value : null;
  }

  function updateQualityLegend(section) {
    const quality = getSelectedQuality(section);
    const legend = section.querySelector('.variant__option__values--jakosc');
    if (!legend || !quality) return;
    const label = legend.closest('fieldset')?.querySelector('[data-selected-value]');
    if (label) label.textContent = GRADE_LABELS[quality] || quality;
  }

  function applyQualityFromQuery(section) {
    const wanted = new URLSearchParams(window.location.search).get(TIER_QUERY);
    if (!wanted) return;
    const input = section.querySelector(
      `.variant__option__values--jakosc input[value="${CSS.escape(wanted)}"]`
    );
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function wireMassLinks(section) {
    section.querySelectorAll('.variant__option__values--mass a').forEach((link) => {
      link.addEventListener('click', (event) => {
        const quality = getSelectedQuality(section);
        if (!quality) return;
        event.preventDefault();
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set(TIER_QUERY, quality);
        window.location.href = url.toString();
      });
    });
  }

  function initSection(section) {
    if (!section.querySelector('variant-selects')) return;
    wireMassLinks(section);
    applyQualityFromQuery(section);
    updateQualityLegend(section);
    section.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) updateQualityLegend(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-info').forEach(initSection);
  });
})();
